module.exports = {
	"config": {
		"siteTitle": "µTool",
		"siteDescription": "(/mu:tool/) creates data-driven digital products and services that give brands a competitive edge.",
		"siteUrl": "http://utool.io",
		"siteVersion": "1.0.0",
		"copyrightMessage": "<a href='http://utool.io' target='_blank'>µTool</a>. All Rights reserved.",
		"linkPrefix": "",
		"gaCode": "UA-68653561-1"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.js",
				"ext": "js",
				"name": "about",
				"extname": ".js",
				"basename": "about.js",
				"dirname": "",
				"stem": "about",
				"path": "about.js",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/about.js",
				"isAbsolute": false
			},
			"requirePath": "about.js",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "about",
				"stem": "index",
				"path": "about/index.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/about/index.md",
				"isAbsolute": false
			},
			"requirePath": "about/index.md",
			"path": "/about/",
			"data": {
				"title": "About Index",
				"layout": "about",
				"path": "/about/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "blog.js",
				"ext": "js",
				"name": "blog",
				"extname": ".js",
				"basename": "blog.js",
				"dirname": "",
				"stem": "blog",
				"path": "blog.js",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/blog.js",
				"isAbsolute": false
			},
			"requirePath": "blog.js",
			"path": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "hello_barcelona.md",
				"ext": "md",
				"name": "hello_barcelona",
				"extname": ".md",
				"basename": "hello_barcelona.md",
				"dirname": "blog",
				"stem": "hello_barcelona",
				"path": "blog/hello_barcelona.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/blog/hello_barcelona.md",
				"isAbsolute": false
			},
			"requirePath": "blog/hello_barcelona.md",
			"path": "/blog/hello_barcelona/",
			"data": {
				"title": "Hello Barcelona",
				"date": "2016-09-09T13:34:12",
				"layout": "post",
				"readNext": "/blog/hello_ny",
				"path": "/blog/hello_barcelona",
				"tags": [
					"react",
					"gatsby",
					"blog"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "hello_internet.md",
				"ext": "md",
				"name": "hello_internet",
				"extname": ".md",
				"basename": "hello_internet.md",
				"dirname": "blog",
				"stem": "hello_internet",
				"path": "blog/hello_internet.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/blog/hello_internet.md",
				"isAbsolute": false
			},
			"requirePath": "blog/hello_internet.md",
			"path": "/blog/hello_internet/",
			"data": {
				"title": "Hello Internet",
				"date": "2016-08-10T21:11:53",
				"layout": "post",
				"readNext": "/blog/hello_barcelona",
				"path": "/blog/hello_internet",
				"tags": [
					"react",
					"gatsby",
					"blog"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "hello_ny.md",
				"ext": "md",
				"name": "hello_ny",
				"extname": ".md",
				"basename": "hello_ny.md",
				"dirname": "blog",
				"stem": "hello_ny",
				"path": "blog/hello_ny.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/blog/hello_ny.md",
				"isAbsolute": false
			},
			"requirePath": "blog/hello_ny.md",
			"path": "/blog/hello_ny/",
			"data": {
				"title": "Hello NY",
				"date": "2016-09-07T17:12:34",
				"layout": "post",
				"readNext": "/blog/hello_world",
				"path": "/blog/hello_ny",
				"tags": [
					"react",
					"gatsby",
					"blog"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "hello_world.md",
				"ext": "md",
				"name": "hello_world",
				"extname": ".md",
				"basename": "hello_world.md",
				"dirname": "blog",
				"stem": "hello_world",
				"path": "blog/hello_world.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/blog/hello_world.md",
				"isAbsolute": false
			},
			"requirePath": "blog/hello_world.md",
			"path": "/blog/hello_world/",
			"data": {
				"title": "Hello World",
				"date": "2016-08-11T22:12:54",
				"layout": "post",
				"readNext": "/blog/hello_internet",
				"path": "/blog/hello_world",
				"tags": [
					"react",
					"gatsby",
					"blog"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "manifesto.js",
				"ext": "js",
				"name": "manifesto",
				"extname": ".js",
				"basename": "manifesto.js",
				"dirname": "",
				"stem": "manifesto",
				"path": "manifesto.js",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/manifesto.js",
				"isAbsolute": false
			},
			"requirePath": "manifesto.js",
			"path": "/manifesto/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "process.js",
				"ext": "js",
				"name": "process",
				"extname": ".js",
				"basename": "process.js",
				"dirname": "",
				"stem": "process",
				"path": "process.js",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/process.js",
				"isAbsolute": false
			},
			"requirePath": "process.js",
			"path": "/process/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "process",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process",
				"stem": "index",
				"path": "process/index.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/process/index.md",
				"isAbsolute": false
			},
			"requirePath": "process/index.md",
			"path": "/process/",
			"data": {
				"title": "Process Index",
				"layout": "process",
				"path": "/process/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "tools.js",
				"ext": "js",
				"name": "tools",
				"extname": ".js",
				"basename": "tools.js",
				"dirname": "",
				"stem": "tools",
				"path": "tools.js",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/tools.js",
				"isAbsolute": false
			},
			"requirePath": "tools.js",
			"path": "/tools/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "tools",
				"base": "blog.md",
				"ext": "md",
				"name": "blog",
				"extname": ".md",
				"basename": "blog.md",
				"dirname": "tools",
				"stem": "blog",
				"path": "tools/blog.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/tools/blog.md",
				"isAbsolute": false
			},
			"requirePath": "tools/blog.md",
			"path": "/tools/blog/",
			"data": {
				"title": "Blog",
				"date": "2016-08-12T22:12:54",
				"layout": "tool",
				"path": "/tools/blog"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "tools",
				"base": "landing_page_builder.md",
				"ext": "md",
				"name": "landing_page_builder",
				"extname": ".md",
				"basename": "landing_page_builder.md",
				"dirname": "tools",
				"stem": "landing_page_builder",
				"path": "tools/landing_page_builder.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/tools/landing_page_builder.md",
				"isAbsolute": false
			},
			"requirePath": "tools/landing_page_builder.md",
			"path": "/tools/landing_page_builder/",
			"data": {
				"title": "Landing Page Builder",
				"date": "2016-08-11T22:12:54",
				"layout": "tool",
				"path": "/tools/landing_page_builder"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "work.js",
				"ext": "js",
				"name": "work",
				"extname": ".js",
				"basename": "work.js",
				"dirname": "",
				"stem": "work",
				"path": "work.js",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/work.js",
				"isAbsolute": false
			},
			"requirePath": "work.js",
			"path": "/work/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "project_sample.md",
				"ext": "md",
				"name": "project_sample",
				"extname": ".md",
				"basename": "project_sample.md",
				"dirname": "work",
				"stem": "project_sample",
				"path": "work/project_sample.md",
				"absolute": "/Users/dvz/Projects/gatsby-utool.io/work/project_sample.md",
				"isAbsolute": false
			},
			"requirePath": "work/project_sample.md",
			"path": "/work/project_sample/",
			"data": {
				"title": "Project Sample",
				"date": "2016-08-11T22:12:54",
				"layout": "project",
				"path": "/work/project_sample",
				"tags": [
					"react",
					"gatsby",
					"project"
				]
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 378
// module chunks = 0